import Link from 'next/link'

const Downloads = ({ data, marginLess = false, idx }) => {
  const { titulo, color, items } = data
  return (
    <div className="max-w-6xl mx-auto">
      <div
        className={`${!marginLess ? 'mt-10 ml-12 mr-10 mb-20 lg:mr-20' : ''}`}
      >
        <div
          className={`${!marginLess ? 'mt-20' : `${idx !== 0 ? 'mt-20' : ''}`}`}
        >
          {titulo && (
            <h2 className="font-alliance-medium text-[42px] mb-10">{titulo}</h2>
          )}
        </div>
        <div className="mt-20 grid grid-cols-1 lg:flex flex-wrap gap-6">
          {items.map((item, idx) => {
            const { titulo, link } = item
            return (
              <Link
                key={idx}
                href={link}
                className={` group text-blue ${
                  color === '#C8CCCC' ? 'hover:text-white' : ''
                }`}
              >
                <div
                  style={{
                    backgroundColor: color !== '#C8CCCC' ? color : ''
                  }}
                  className="grid place-content-between font-alliance-medium text-[24px] lg:text-[28px] rounded-sm p-8 lg:w-[474px] lg:h-[250px] bg-grey group-hover:bg-blue"
                >
                  <p className="mb-10 lg:mb-0">{titulo}</p>
                  <img
                    src={`/assets/icons/download.svg`}
                    alt="icon"
                    className={`mr-5 block ${
                      color === '#C8CCCC' ? 'group-hover:hidden' : ''
                    }`}
                  />
                  <img
                    src={`/assets/icons/download-white.svg`}
                    alt="icon"
                    className={`mr-5 hidden ${
                      color === '#C8CCCC' ? 'group-hover:block' : ''
                    }`}
                  />
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}
export default Downloads
